import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiTrendingDown, FiCheck } = FiIcons;

const HeroSection = () => {
  const scrollToScheduling = () => {
    document.getElementById('scheduling')?.scrollIntoView({ behavior: 'smooth' });
  };

  const benefits = [
    'No contracts or commitments',
    'Local Hudson Valley support',
    'Free migration assistance'
  ];

  return (
    <section className="relative overflow-hidden min-h-screen flex items-center">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover">
          <source src="https://s3.us-east-2.wasabisys.com/crc-cdn/crc/HV-Bridge-Hero.mp4" type="video/mp4" />
        </video>
        {/* Dark to Light Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-blue-900/60 to-blue-600/40"></div>
      </div>

      <div className="relative z-10 w-4/5 mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="max-w-3xl"
        >
          <div className="flex items-center space-x-3 mb-8">
            <span className="bg-green-500/20 backdrop-blur-sm text-green-300 px-4 py-2 rounded-full text-sm font-medium border border-green-400/30">
              Save Up To 30%
            </span>
            <SafeIcon icon={FiTrendingDown} className="h-6 w-6 text-green-400" />
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-8">
            Modern VoIP,
            <span className="text-blue-300 block">Local Support</span>
          </h1>

          <p className="text-xl text-white/90 mb-10 leading-relaxed max-w-2xl">
            Switch from overpriced providers to 3CX. Get enterprise features with Hudson Valley support.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 mb-10">
            <button
              onClick={scrollToScheduling}
              className="bg-blue-600 text-white px-10 py-5 rounded-xl hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 font-medium text-lg flex items-center justify-center space-x-3 shadow-2xl backdrop-blur-sm border border-blue-500/30"
            >
              <span>Calculate Your Savings</span>
              <SafeIcon icon={FiArrowRight} className="h-6 w-6" />
            </button>
          </div>

          <div className="space-y-4">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                className="flex items-center space-x-3 text-white/90"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.8 + (index * 0.1) }}
              >
                <div className="bg-green-500/20 backdrop-blur-sm p-1 rounded-full border border-green-400/30">
                  <SafeIcon icon={FiCheck} className="h-4 w-4 text-green-400" />
                </div>
                <span className="font-medium">{benefit}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;